/*
  login-user.js
    Login User module

    Login User Information
      user_id,
      name,
      company_id,
      staff_id,
      class,
      dist,
      comment,
      return,
*/
import * as types from '@/store/mutation-types'
import {
  getWhereaboutsInfoByMember,
  changePassword,
  getAvatarInfoByMember,
  uploadAvatar,
  deleteAvatar,
  //updateCalendarKey,
  changeTeleworkFlg,
  changeLinkedTelework,
} from '@/api'
import { sLog } from '@/common/simple-logger'
import { LS_TOKEN_KEY, isNullorUndefined } from '@/common'

export default {
  state: {
    sUserBaseInfo: {},
    sUserInfo: {},
  },
  getters: {
    loginUserBaseInfo: state => state.sUserBaseInfo,
    loginUserId: state => state.sUserBaseInfo.user_id,
    loginUserCompanyId: state => state.sUserBaseInfo.company_id,
    loginUserInfo: state => state.sUserInfo,
  },
  actions: {
    // -------------------------------------------------------------------------
    // set login user all information
    aSetLoginUserAllInfo: async (context, payload) => {
      sLog.debug('@action set login user all information : ' + payload.user_id)
      // ユーザ情報の取得が遅いので、先に基本情報をstoreに保存する
      context.commit(types.SET_LOGIN_USER_BASE, payload)
      const result = await getWhereaboutsInfoByMember(
        payload.company_id,
        payload.user_id,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (!result.error && !result.body.error) {
        context.commit(types.SET_LOGIN_USER, result.body.body)
      }
    },
    // -------------------------------------------------------------------------
    // set login user information
    aSetLoginUserInfo: async (context, payload) => {
      sLog.debug('@action set login user information : ' + payload.user_id)
      context.commit(types.SET_LOGIN_USER, payload)
    },
    // -------------------------------------------------------------------------
    // change password
    aChangePassword: async (context, payload) => {
      sLog.debug('@action change password user id : ' + context.state.sUserInfo.user_id)
      const result = await changePassword(
        context.state.sUserInfo.user_id,
        payload.oldpasswd,
        payload.newpasswd,
        localStorage.getItem(LS_TOKEN_KEY),
      )
      return result
    },
    // -------------------------------------------------------------------------
    // get whereabouts info
    aGetLoginUserWhereaboutsInfo: async (context) => {
      if (isNullorUndefined(context.state.sUserBaseInfo.company_id) ||
          isNullorUndefined(context.state.sUserBaseInfo.user_id)) {
        sLog.error('@action get whereabouts info : UserBaseInfo is null')
        return
      }
      const result = await getWhereaboutsInfoByMember(
        context.state.sUserBaseInfo.company_id,
        context.state.sUserBaseInfo.user_id,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (!result.error && !result.body.error) {
        context.commit(types.SET_LOGIN_USER, result.body.body)
      }
    },
    // -------------------------------------------------------------------------
    // get avatar info
    aGetLoginUserAvatarInfo: async (context) => {
      if (isNullorUndefined(context.state.sUserBaseInfo.company_id) ||
          isNullorUndefined(context.state.sUserBaseInfo.user_id)) {
        sLog.error('@action get avatar info : UserBaseInfo is null')
        return
      }
      sLog.debug('@action get avatar info ')
      const result = await getAvatarInfoByMember(
        context.state.sUserBaseInfo.company_id,
        context.state.sUserBaseInfo.user_id,
        localStorage.getItem(LS_TOKEN_KEY),
      )

      if (!result.error && !result.body.error) {
        let updata = {
          user_id: context.state.sUserInfo.user_id,
          userList: context.rootState.sUserList,
          url: result.body.body.avatar,
        }
        context.commit(types.SET_AVATAR_URL, updata)
      }

      return result
    },
    // -------------------------------------------------------------------------
    // upload avatar
    aUploadAvatar: async (context, payload) => {
      if (isNullorUndefined(context.state.sUserBaseInfo.company_id) ||
          isNullorUndefined(context.state.sUserBaseInfo.user_id)) {
        sLog.error('@action upload avatar : UserBaseInfo is null')
        return null
      }
      sLog.debug('@action upload avatar : ' + payload)
      const result = await uploadAvatar(
        payload.company_id,
        payload.user_id,
        payload.form_data,
        localStorage.getItem(LS_TOKEN_KEY),
      )
      if (!result.error && !result.body.error) {
        // Listを更新
        let updata = {
          user_id: payload.user_id,
          userList: context.rootState.sUserList,
          url: result.body.body,
        }
        context.commit(types.SET_AVATAR_URL, updata)
      }
      return result
    },
    // -------------------------------------------------------------------------
    // delete avatar
    aDeleteAvatar: async (context, payload) => {
      if (isNullorUndefined(context.state.sUserBaseInfo.company_id) ||
          isNullorUndefined(context.state.sUserBaseInfo.user_id)) {
        sLog.error('@action upload avatar : UserBaseInfo is null')
        return null
      }
      sLog.debug('@action delete avatar : ' + payload)
      const result = await deleteAvatar(
        payload.company_id,
        payload.user_id,
        localStorage.getItem(LS_TOKEN_KEY),
      )
      if (!result.error && !result.body.error) {
        // Listを更新
        let updata = {
          user_id: payload.user_id,
          userList: context.rootState.sUserList,
          url: null,
        }
        context.commit(types.DELETE_AVATAR_URL, updata)
      }
      return result
    },
    /*
    // -------------------------------------------------------------------------
    // update calendar key
    aUpdateCalendarKey: async (context, payload) => {
      if (isNullorUndefined(context.state.sUserBaseInfo.company_id) ||
          isNullorUndefined(context.state.sUserBaseInfo.user_id)) {
        sLog.error('@action update calendar key : UserBaseInfo is null')
        return null
      }
      sLog.debug('@action update calendar key user id : ' + context.state.sUserBaseInfo.user_id)
      let result = await updateCalendarKey(
        context.state.sUserBaseInfo.company_id,
        context.state.sUserBaseInfo.user_id,
        payload.calendarKey)
      return result
    },
    */
    // -------------------------------------------------------------------------
    // Change telework mode
    aChangeTeleworkFlg: async (context, payload) => {
      sLog.debug('@action aChangeTeleworkFlg ' + JSON.stringify(payload))

      const result = await changeTeleworkFlg(
        payload.user_id,
        payload.telework_flg,
        localStorage.getItem(LS_TOKEN_KEY)
      )

      if (!result.error && !result.body.error) {
        // 正常に保存完了した場合は、localstrageにも保存
        let updata = {
          user_id: payload.user_id,
          userList: context.rootState.sWhereaboutsList,
          telework_flg: payload.telework_flg,
        }
        context.commit(types.SET_TELEWORK_FLG, updata)
      }

      return result
    },
    // -------------------------------------------------------------------------
    // Change linked telework mode
    aChangeLinkedTelework: async (context, payload) => {
      sLog.debug('@action aChangeLinkedTelework ' + JSON.stringify(payload))

      const result = await changeLinkedTelework(
        payload.user_id,
        payload.linked_wh,
        localStorage.getItem(LS_TOKEN_KEY)
      )

      if (!result.error && !result.body.error) {
        // 正常に保存完了した場合は、localstrageにも保存
        context.commit(types.SET_LINKED_TELEWORK, payload.linked_wh)
      }

      return result
    },
    // -------------------------------------------------------------------------
    // set latest telework category
    aSetLatestTeleworkCategory: async (context, category) => {
      sLog.debug('@action aSetLatestTeleworkCategory ' + category)
      context.commit(types.SET_LATEST_WH_CATEGORY, category)
    },
  },
  mutations: {
    // -------------------------------------------------------------------------
    // set login user base information
    [types.SET_LOGIN_USER_BASE] (state, baseinfo) {
      // 保存のタイミングでTelework情報を書き換えておく
      //baseinfo.telework = (baseinfo.telework_flg === 1 || baseinfo.telework_flg === '1')
      sLog.debug('@store login user base info : ' + JSON.stringify(baseinfo))
      state.sUserBaseInfo = baseinfo
    },
    // -------------------------------------------------------------------------
    // set login user information
    [types.SET_LOGIN_USER] (state, whereaboutsInfo) {
      sLog.debug('@store login user info : ' + JSON.stringify(whereaboutsInfo))
      state.sUserInfo = whereaboutsInfo
    },
    // -------------------------------------------------------------------------
    // set avatar URL
    [types.SET_AVATAR_URL] (state, updateData) {
      //sLog.debug('@store set avatar url : ' + JSON.stringify(updateData))
      sLog.debug('@store set avatar url : ' + JSON.stringify(updateData.url))
      sLog.debug('@store set avatar url before: ' + JSON.stringify(state.sUserBaseInfo.avatar))
      let user_info = updateData.userList.find((userInfo) => {
        return (userInfo.user_id.toString() === updateData.user_id.toString())
      })
      if (isNullorUndefined(user_info)) {
        // @Todo System Error
        return
      }
      user_info.avatar = updateData.url
      state.sUserBaseInfo.avatar = updateData.url
      sLog.debug('@store set avatar url after : ' + JSON.stringify(state.sUserBaseInfo.avatar))
    },
    // -------------------------------------------------------------------------
    // delete avatar URL
    [types.DELETE_AVATAR_URL] (state, updateData) {
      sLog.debug('@store delete avatar url : ' + JSON.stringify(updateData.url))
      sLog.debug('@store delete avatar url before: ' + JSON.stringify(state.sUserBaseInfo.avatar))
      let user_info = updateData.userList.find((userInfo) => {
        return (userInfo.user_id.toString() === updateData.user_id.toString())
      })
      if (isNullorUndefined(user_info)) {
        // @Todo System Error
      }
      user_info.avatar = updateData.url
      state.sUserBaseInfo.avatar = updateData.url
      sLog.debug('@store delete avatar url after : ' + JSON.stringify(state.sUserBaseInfo.avatar))
    },
    // -------------------------------------------------------------------------
    // Set telework mode
    [types.SET_TELEWORK_FLG] (state, updateData) {
      // ユーザリストに反映
      let user_info = updateData.userList.find((userInfo) => {
        return (userInfo.user_id.toString() === updateData.user_id.toString())
      })
      sLog.debug('ログインユーザ検索 : ' + JSON.stringify(user_info))
      if (!isNullorUndefined(user_info)) {
        user_info.telework_flg = updateData.telework_flg
      }

      state.sUserBaseInfo.telework_flg = updateData.telework_flg
      sLog.debug('@store set telework flg : ' + state.sUserBaseInfo.telework_flg)
    },
    // -------------------------------------------------------------------------
    // Set linked telework mode
    [types.SET_LINKED_TELEWORK] (state, linkedTw) {
      state.sUserBaseInfo.linked_wh_flg = linkedTw
      sLog.debug('@store set linked telework flg : ' + state.sUserBaseInfo.linked_wh_flg)
    },
    // -------------------------------------------------------------------------
    // Set latest telework category
    [types.SET_LATEST_WH_CATEGORY] (state, category) {
      state.sUserInfo.latest_wh_category = category
      sLog.debug('@store set latest telework category : ' + state.sUserInfo.latest_wh_category)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/login-user.js